import { Divider, FluentProvider } from "@fluentui/react-components";
import { Label, RadioButton, TextStyle, duploLightTheme, Button } from "@lannister/duplo";

import { ReactComponent as CardIcon } from "../../assets/icons/card.svg";
import { ReactComponent as EmptyWallet } from "../../assets/icons/empty-wallet.svg";
import { ReactComponent as PCILogo } from "../../assets/images/PCI-Logo.svg";
import { ReactComponent as SahlLogo } from "../../assets/images/Sahl-Logo.svg";
import Wallet from './wallet';
import CardDetailsForm from './cardDetailsForm';

const PaymentMethods = ({
    isCardEnabled,
    isWalletEnabled,
    form,
    handleChange,
    onSubmit,
    onChangeSelectedPaymentMethod }) => {

    const getOptions = () => {
        const options = [];
        if (isCardEnabled) {
            options.push({
                label: "Debit or Credit Card",
                value: "1",
                icon: <CardIcon />,
                content: <CardDetailsForm form={form} handleChange={handleChange} />
            });
        }

        if (isWalletEnabled) {
            options.push({ 
                label: "Digital Wallet",
                value: "3",
                icon: <EmptyWallet />,
                content: <Wallet form={form} handleChange={handleChange} />
            });
        }

        return options;
    };

    return (
        <FluentProvider theme={duploLightTheme}>
            <div style={styles.card}>
                <Label labelText="Choose your payment method" textStyle={TextStyle.Heading5Semibold} />
                <RadioButton
                    options={getOptions()}
                    onChange={(value) => onChangeSelectedPaymentMethod(Number(value))}
                />
            </div>

            <div style={styles.row}>
                <div style={styles.sahl}>
                    <Label labelText="Powered by" textStyle={TextStyle.BaseRegular} />
                    <SahlLogo />
                </div>
                <div style={{ maxWidth: "fitContent" }}>
                    <Divider vertical />
                </div>
                <PCILogo />
            </div>

            <div style={{ display: "grid", padding: "12px 0" }}>
                <Button onClick={(e) => onSubmit(e)}>
                    Pay 
                </Button>
            </div>
        </FluentProvider>
    );
}

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E0E0E0",
    backgroundColor: "#FFFFFF",
    width: "100%",
    boxSizing: "border-box",
  },
  row: {
    display: "flex",
    padding: "12px 0 0 0",
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
    alignSelf: "stretch",
  },
  sahl: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    gap: "8px",
    flexWrap: "wrap",
  }
};

export default PaymentMethods;